module.exports = __webpack_public_path__ + "img/tictactoeProject.9adbb922.jpeg";